.header {
  display: flex;
  flex-direction: row;
  gap: var(--spacingLg);
}

.matchStatus {
  display: flex;
  flex-direction: column;
  gap: var(--spacingMd);
  min-width: 170px;
  width: 170px;
}

.matchProfile {
  flex: 1;
  display: flex;
  flex-flow: row wrap;
  gap: var(--spacingMd);
  justify-content: space-between;
}

.matchProfileCompressed {
  flex-direction: column;
}

.iconsWrapper {
  display: flex;
  flex-direction: row;
}

.buttonsCompressed {
  width: 100%;
  align-items: stretch;
}
